import { Modal, Button } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { autosaveInfoColor, darkgrey, saveButtonBackgroundColor, warningred } from 'styles/Colors';
import { ReactComponent as RotateIcon } from 'images/rotateIcon.svg';
import { ReactComponent as InfoIcon } from 'images/infoIcon.svg';

export const StyledModal = styled((props) => <Modal {...props} />)`
  .MuiPaper-root {
    width: 960px;

    div[class*="-modalBody-"] {
      height: 673px;
    }
  }

  .required {
    box-shadow: inset 0px 0px 0px 1px ${warningred};
  }
`;

export const Content = styled.div`
  padding: 0 13px 18px 24px;
  position: relative;
`;

export const Divider = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
  height: 0px;
`;

export const InfoNote = styled.p`
  width: 100%;
  margin-top: 15px;
  font-size: 13px;
  color: ${autosaveInfoColor};
  display: flex;
  align-items: center;

  color: var(--Grayscale-Dark-Gray, #7b7b7b);
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
`;

export const Controls = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const StyledInfoIcon = styled((props) => <InfoIcon {...props} />)`
  margin-right: 4px;
`;

export const LoaderWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  backdrop-filter: blur(1px);

  div {
    height: 100%;
  }
`;

export const StyledRotateIcon = styled((props) => <RotateIcon {...props} />)`
  margin-right: 11px;
`;

export const StyledButton = styled((props) => <Button {...props} />)`
  &&& {
    color: ${darkgrey};
    background-color: ${saveButtonBackgroundColor};
    display: flex;
    flex-direction: row-reverse;

    &:hover {
      opacity: 1;
      box-shadow: none;
    }

    &:active {
      background-color: ${saveButtonBackgroundColor} !important;
    }

    .MuiButton-endIcon {
      margin-right: unset;
      margin-left: unset;

      div {
        position: static;
      }
    }
  }
`;

export const TabsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RefreshWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  color: #414141;
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
  text-align: right;
`;

export const RefreshTime = styled.div`
  color: #a0a0a0;
`;
